import { LitElement } from 'lit';
import Flatpickr from 'flatpickr';
import FlatpickrMonthSelect from 'flatpickr/dist/plugins/monthSelect';
import 'flatpickr/dist/l10n/de';
import { monthIsSupported } from './lib/toujou-datepicker-helper';

export class ToujouDatepicker extends LitElement {
  static get is() {
    return 'toujou-datepicker';
  }

  static get properties() {
    return {
      mode: {
        type: String,
      },
      dateFormat: {
        type: String,
        attribute: 'date-format',
      },
      altFormat: {
        type: String,
        attribute: 'alt-format',
      },
      minDate: {
        type: String,
      },
      maxDate: {
        type: String,
      },
      enableTime: {
        type: Boolean,
      },
      monthPicker: {
        type: Boolean,
      },
    };
  }

  constructor() {
    super();
    this.dateFormat = 'd.m.Y';
    this.mode = 'single';
    this.altFormat = null;
    this.minDate = null;
    this.maxDate = null;
    this.enableTime = false;
    this.monthPicker = false;
  }

  createRenderRoot() {
    return this;
  }

  connectedCallback() {
    super.connectedCallback();
    const locale = document.documentElement.getAttribute('lang') || 'en-US';

    const localeRoot = locale.substring(0, 2);
    if (Flatpickr.l10ns[localeRoot]) {
      Flatpickr.localize(Flatpickr.l10ns[localeRoot]);
    }

    const inputElement = this.querySelector('input');
    if (inputElement) {
      this._initDatepicker(inputElement);
    }
  }

  /**
   * @param {HTMLInputElement} inputElement
   */
  _initDatepicker(inputElement) {
    const confObj = {
      dateFormat: this.dateFormat,
      altInput: this.altFormat !== null,
      altFormat: this.altFormat ? this.altFormat : this.dateFormat,
      minDate: this.minDate,
      maxDate: this.maxDate,
      enableTime: this.enableTime,
      time_24hr: true,
      allowInput: false,
      mode: this.mode,
      onClose(selectedDates, dateStr, instance) {
        const closeEvent = new CustomEvent('close', {
          bubbles: true,
          composed: true,
          detail: {
            selectedDates,
            dateStr,
            instance,
          },
        });
        inputElement.dispatchEvent(closeEvent);
      },

    };

    if (this.monthPicker) {
      const defaultMonthDateFormat = 'F Y';
      confObj.altInput = true;
      if (window.navigator.maxTouchPoints === 0 || !monthIsSupported()) {
        confObj.plugins = [new FlatpickrMonthSelect({
          altFormat: defaultMonthDateFormat,
        })];
      } else {
        confObj.altFormat = defaultMonthDateFormat;
      }
    }
    const valueAttribute = inputElement.getAttribute('value');
    if (valueAttribute && valueAttribute !== '') {
      try {
        confObj.defaultDate = Flatpickr.parseDate(valueAttribute, this.dateFormat);
      } catch (e) {
        // invalid date: skip
      }
    }

    Flatpickr(inputElement, confObj);
  }
}

customElements.define(ToujouDatepicker.is, ToujouDatepicker);
